import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import Base from '../base';
import Gikam from 'gikam';
var defaultOptions = {
  url: null
};

var WorkflowOpinionTimeline = /*#__PURE__*/function (_Base) {
  _inherits(WorkflowOpinionTimeline, _Base);

  var _super = _createSuper(WorkflowOpinionTimeline);

  function WorkflowOpinionTimeline(options) {
    var _this;

    _classCallCheck(this, WorkflowOpinionTimeline);

    _this = _super.call(this, 'WorkflowOpinionTimeline');

    _this.initialize(options, defaultOptions);

    _this.init();

    return _this;
  }

  _createClass(WorkflowOpinionTimeline, [{
    key: "init",
    value: function init() {
      this.initViewData();
      this.getOpinionList();
      this.createModel();
    }
  }, {
    key: "initViewData",
    value: function initViewData() {
      this.viewData = {
        opinionList: []
      };
    }
  }, {
    key: "createModel",
    value: function createModel() {
      var h = this.$createElement;
      this.model = new Vue({
        el: Gikam.createDom('div', this.options.renderTo),
        data: this.viewData,
        components: {
          TimeLine: function TimeLine() {
            return import('./workflow-opinion-timeline.vue');
          }
        },
        render: function render() {
          var h = arguments[0];
          return h("TimeLine", {
            "attrs": {
              "opinionList": this.opinionList
            }
          });
        }
      });
    }
  }, {
    key: "getOpinionList",
    value: function getOpinionList() {
      var _this2 = this;

      Gikam.post(this.options.url).done(function (data) {
        _this2.viewData.opinionList = data.rows;
      });
    }
  }]);

  return WorkflowOpinionTimeline;
}(Base);

export { WorkflowOpinionTimeline as default };